<template>
  <div class="checkOrderRight">
    <div>
      <el-tabs v-model="activeName" type="card">
 
        <el-tab-pane label="图片信息" name="one">
          <div>
            <el-tabs v-model="photoName" type="card">
              <el-tab-pane label="现场图片" name="liveImageDataList">
                <ul class="photoBox">
                  <li v-for="item in detail.liveImageDataList" :key="item.id">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="item.imageUrl"
                      :z-index="9999"
                      :preview-src-list="
                        detail.liveImageDataList.map((it) => it.imageUrl)
                      "
                    >
                    </el-image>
                  </li>
                </ul>
              </el-tab-pane>
              <el-tab-pane label="工单图片" name="orderImageDataList">
                <ul class="photoBox">
                  <li v-for="item in detail.orderImageDataList" :key="item.id">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="item.imageUrl"
                      :z-index="9999"
                      :preview-src-list="
                        detail.orderImageDataList.map((it) => it.imageUrl)
                      "
                    >
                    </el-image>
                  </li>
                </ul>
              </el-tab-pane>
              <el-tab-pane label="签名图片" name="signatureImageDataList">
                <ul class="photoBox">
                  <li
                    v-for="item in detail.signatureImageDataList"
                    :key="item.id"
                  >
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="item.imageUrl"
                      :z-index="9999"
                      :preview-src-list="
                        detail.signatureImageDataList.map((it) => it.imageUrl)
                      "
                    >
                    </el-image>
                  </li>
                </ul>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-tab-pane>
        <el-tab-pane label="位置信息" name="two">
          <span>提示：如果没有电梯标示，请及时进行电梯定位操作。</span>
          <MapBox :detail="detail"/>
        </el-tab-pane>
        <!-- <el-tab-pane label="保养项目" name="three">
          <el-table
            :data="detail.manageItemDTOS"
            style="width: 100%"
            max-height="600px"
          >
            <el-table-column prop="itemName" label="名称" width="100">
            </el-table-column>
            <el-table-column prop="locationName" label="部位" width="70">
            </el-table-column>
            <el-table-column
              prop="requirements"
              label="要求"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="result"
              width="100"
              label="记录"
              show-overflow-tooltip
            >
            <template slot-scope="scope">
              {{scope.row.result | filterR}}
            </template>
            </el-table-column>
          </el-table>
        </el-tab-pane> -->
        <el-tab-pane label="电梯信息" name="four">
          <div class="liftDetailBox">
            <div class="liftDetail">
              <p>电梯信息</p>
              <ul>
                <li>
                  <span>电梯类型</span
                  ><span>{{ detail.lift.liftTypeName }}</span>
                </li>
                <li>
                  <span>使用单位</span
                  ><span>{{ detail.lift.propertyUnitName }}</span>
                </li>
                <li>
                  <span>项目名称</span
                  ><span>{{ detail.lift.projectName }}</span>
                </li>
                <li>
                  <span>电梯品牌</span><span>{{ detail.lift.liftBrand }}</span>
                </li>
                <li>
                  <span>制造单位</span
                  ><span>{{ detail.lift.manufactureCompany }}</span>
                </li>
                <li>
                  <span>制造日期</span
                  ><span>{{ detail.lift.manufactureDate }}</span>
                </li>
                <li>
                  <span>安装单位</span
                  ><span>{{ detail.lift.installCompany }}</span>
                </li>
                <li>
                  <span>载重</span><span>{{ detail.lift.nominalLoad }}</span>
                </li>
                <li>
                  <span>层站数</span
                  ><span>{{ detail.lift.stationNumber }}</span>
                </li>
                <li>
                  <span>控制方式</span
                  ><span>{{ detail.lift.controlMode }}</span>
                </li>
                <li>
                  <span>额定速度</span
                  ><span>{{ detail.lift.nominalSpeed }}</span>
                </li>
                <li>
                  <span>出厂编号</span
                  ><span>{{ detail.lift.factoryNumber }}</span>
                </li>
                <li>
                  <span>运行方式</span
                  ><span>{{ detail.lift.modeOperation }}</span>
                </li>
                <li>
                  <span>设备型号</span><span>{{ detail.lift.unitType }}</span>
                </li>
                <li>
                  <span>使用证编号</span
                  ><span>{{ detail.lift.useCertificateNumber }}</span>
                </li>
                <li>
                  <span>注册代码</span
                  ><span>{{ detail.lift.registerCode }}</span>
                </li>
                <li>
                  <span>注册单位</span
                  ><span>{{ detail.lift.registeredUnit }}</span>
                </li>
              </ul>
            </div>
            <div class="contractDetail">
              <p>合同信息</p>
              <ul>
                <li>
                  <span>付款日期</span
                  ><span>{{ detail.lift.paymentDate }}</span>
                </li>
                <li>
                  <span>维保合同到期时间</span
                  >{{ detail.lift.maintenanceEndDate }}<span></span>
                </li>
                <li>
                  <span>合同联系人</span
                  ><span>{{ detail.lift.contractContact }}</span>
                </li>
                <li>
                  <span>联系电话</span
                  ><span>{{ detail.lift.contractContactPhone }}</span>
                </li>
                <li>
                  <span>配件约定</span
                  ><span>{{ detail.lift.accessoriesAmount }}</span>
                </li>
                <li>
                  <span>税收票证</span><span>{{ detail.lift.taxTicket }}</span>
                </li>
                <li>
                  <span>维保间隔</span
                  ><span>{{ detail.lift.maintenanceInterval }}</span>
                </li>
              </ul>
            </div>
            <div class="yearDetail">
              <p>年检信息</p>
              <ul>
                <li>
                  <span>检验人员</span
                  ><span>{{ detail.lift.inspectionPersonnel }}</span>
                </li>
                <li>
                  <span>检验单位</span
                  ><span>{{ detail.lift.inspectionUnit }}</span>
                </li>
                <li>
                  <span>年检报告编号</span
                  ><span>{{ detail.lift.inspectionReportCode }}</span>
                </li>
                <li>
                  <span>年检日期</span
                  ><span>{{ detail.lift.annualInspectionDate }}</span>
                </li>
                <li>
                  <span>下次年检日期</span
                  ><span>{{ detail.lift.nextAnnualInspectionDate }}</span>
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="收费情况" name="five">
          <ChangingSituation @submitForm="submitForm" :accessories="detail.materialRecordList" :peoples="detail.teamworkList" :repairOrderId="detail.orderId" :orderOriginCost="detail.orderOriginCost" :status="detail.status"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import MapBox from "./MapBox";
import ChangingSituation from './ChangingSituation'
export default {
  components: {
    MapBox,
    ChangingSituation
  },
  props: {
    detail: {
      type: Object,
      default: () => {
        return {
          lift: {},
          liveImageDataList: [],
          logList: [],
          teamworkList: [],
          materialRecordList: [],
          orderOriginCost: {},
          stasus: null
        };
      },
    },
  },
  data() {
    return {
      activeName: "one",
      photoName: "liveImageDataList",
    };
  },
  methods: {
    submitForm() {
      this.$emit('submitForm')
    }
  },
  filters: {
    filterR(val) {
      if (val == 1) {
        return '正常'
      } else if (val == 2) {
        return '出错'
      } else if (val == 3) {
        return '无此项'
      } else if (val == 4) {
        return '问题已整改'
      } else if (val == 5) {
        return '已更换零件'
      } else {
        return ''
      }
    }
  }
};
</script>
<style lang="scss">
.checkOrderRight {
  padding-left: 20px;
  .photoBox {
    display: flex;
    li {
      margin-right: 20px;
    }
  }
  .liftDetailBox {
    max-height: 600px;
    overflow-y: auto;
    border: 1px solid #ccc;
    border-bottom: none;
    p {
      padding: 4px 0;
      border-bottom: 1px solid #ccc;
      text-align: center;
      // border-top: 1px solid #ccc;
    }
    .liftDetail p {
      border-top: none;
    }
    li {
      border-bottom: 1px solid #ccc;
      display: flex;
      span {
        flex: 0.4;
        padding: 4px 0;
        padding-left: 20px;
      }
      span:last-child {
        flex: 0.6;
        border-left: 1px solid #ccc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AnnualInspection/components/CheckOrderRight.vue